module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PzW3Fy/tc-custom/9781426878794.jpg?1721429532266",
      "alt": "This image is the cover for the book High-Altitude Doctor"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("High-Altitude Doctor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The love between two doctors heats up the frozen heights of Mount Everest in this romantic adventure by a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Dr. Juliet Adams is an expert in her field of high-altitude medicine and she’s about to take on the most dangerous, grueling challenge of all—Mount Everest!"), _c('br'), _c('br'), _vm._v("It’s Juliet’s life ambition to reach the summit to finish what her brother couldn’t—he died climbing it. But one man stands in her way. Brooding Dr. Finn McBride is also on the expedition, and it’s their job to work together, trust each other and ensure everyone’s safety, when every moment could be fatal. Finn’s instinct is to protect his determined, beautiful colleague. He knows she’s got secrets, but on Everest, there’s nowhere to hide.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Morgan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sarah Morgan is a USA Today and Sunday Times bestselling author of contemporary romance and women's fiction. She has sold more than 21 million copies of her books and her trademark humour and warmth have gained her fans across the globe. Sarah lives with her family near London, England, where the rain frequently keeps her trapped in her office. Visit her at www.sarahmorgan.com ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0